'use client';

import { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import NewsletterSubscription from './subComponent/NewsletterSubscription';

export default function Form_Section() {
  const titleRef = useRef(null);
  const pRef = useRef(null);

  useEffect(() => {
    const isMobile = window.matchMedia('(max-width: 640px)').matches;
    if (!isMobile) return;

    const elements = [titleRef.current, pRef.current].filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('drop-animate');
          else entry.target.classList.remove('drop-animate');
        });
      },
      { threshold: 0.5 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#14D8CE',
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: { xs: '20rem', sm: '28rem', md: '42rem', lg: '48rem' },
          px: 2,
          mt: { xs: -4, lg: -6 },
        }}
      >
        <Typography
          ref={titleRef}
          className="form-drop-animate"
          component="h1"
          sx={{
            fontFamily: 'Rammetto One',
            textTransform: 'uppercase',
            fontWeight: 800,
            color: 'black',
            fontSize: { xs: '28px', sm: '36px', md: '42px', lg: '46px', xl: '50px' },
          }}
        >
          The gaming world is evolving.
        </Typography>

        <Typography
          ref={pRef}
          className="form-drop-animate"
          component="p"
          sx={{
            fontFamily: 'Poppins',
            textTransform: 'uppercase',
            color: 'black',
            mt: { xs: 1.5, sm: 2 },
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
            letterSpacing: '0.02em',
          }}
        >
          Want to Join Us???
        </Typography>
        <NewsletterSubscription />
        <Box sx={{ mt: 2.5, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href="/delete-account"
            style={{
              color: '#111827',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
            }}
          >
            Request Account Deletion
          </a>
          <a
            href="/terms"
            style={{
              color: '#111827',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
            }}
          >
            Read Terms & Conditions
          </a>
          <a
            href="/privacy-policy"
            style={{
              color: '#111827',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
            }}
          >
            Read Privacy Policy
          </a>
        </Box>
      </Box>
    </Box>
  );
}
